<template>
  <div class="header-box">
    <div class="scene-name-box">
      <div
        class="name-box"
        :title="sceneInfo.sceneName">
        {{ sceneInfo.sceneName }}
      </div>
      <QrcodeTooltip
        v-if="!isMobileDevice()"
        shareType="scene"
        :linkUrl="linkUrl" />
    </div>
    <div class="toolbar-box">
      <!-- <div
        :class="`item-box ${isActive('elemQuery') ? 'active' : ''}`"
        @click="openToolBar('elemQuery')"
      >
        <div class="icon-box">
          <icon-svg icon-class="icon-goujianchaxun" size="20" class="icon" />
        </div>
        <div class="name-box">构件查询</div>
      </div>
      <div :class="`item-box ${isActive('elemSet') ? 'active' : ''}`">
        <div class="icon-box">
          <icon-svg icon-class="icon-goujianji" size="20" class="icon" />
        </div>
        <div class="name-box">构件集</div>
      </div> -->
      <div
        v-if="isChecked('Project.Single.SceneViewPort.View')"
        :class="`item-box ${isActive('viewport') ? 'active' : ''}`"
        @click="openToolBar('viewport')">
        <div class="icon-box">
          <icon-svg
            icon-class="icon-shikou"
            size="20"
            class="icon" />
        </div>
        <div class="name-box">视 口</div>
      </div>
      <div
        v-if="isChecked('Project.Single.SceneAnnotation.View')"
        :class="`item-box ${isActive('annotation') ? 'active' : ''}`"
        @click="openToolBar('annotation')">
        <div class="icon-box">
          <icon-svg
            icon-class="icon-pizhu"
            size="20"
            class="icon" />
        </div>
        <div class="name-box">批 注</div>
      </div>
      <div
        v-if="isChecked('Project.Single.SceneAnchorPoint.View')"
        :class="`item-box ${isActive('anchor') ? 'active' : ''}`"
        @click="openToolBar('anchor')">
        <div class="icon-box">
          <icon-svg
            icon-class="icon-maodian"
            size="20"
            class="icon" />
        </div>
        <div class="name-box">锚 点</div>
      </div>
      <div
        v-if="isChecked('Project.Single.SceneRoam.View')"
        :class="`item-box ${isActive('roaming') ? 'active' : ''}`"
        @click="openToolBar('roaming')">
        <div class="icon-box">
          <icon-svg
            icon-class="icon-manyou"
            size="20"
            class="icon" />
        </div>
        <div class="name-box">漫 游</div>
      </div>
      <!-- <div :class="`item-box ${isActive('tag') ? 'active' : ''}`">
        <div class="icon-box">
          <icon-svg icon-class="icon-biaoqian" size="20" class="icon" />
        </div>
        <div class="name-box">标 签</div>
      </div>
      <div :class="`item-box ${isActive('screenShot') ? 'active' : ''}`">
        <div class="icon-box">
          <icon-svg icon-class="icon-jietuxiazai" size="20" class="icon" />
        </div>
        <div class="name-box">截图下载</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import QrcodeTooltip from '../../components/QrcodeTooltip.vue'

import { Store } from '@/utils/store'
import { isMobileDevice } from '@/utils/generalMethods'

export default {
  props: {
    sceneInfo: Object,
    linkUrl: String,
    activeToolBar: String,
    openElemSearchDialog: Function,
    openViewPortPanel: Function,
    openRoaming: Function
  },
  components: {
    QrcodeTooltip
  },
  methods: {
    openToolBar(toolBar) {
      switch (toolBar) {
        case 'elemQuery':
          this.openElemSearchDialog(toolBar)
          break
        case 'elemSet':
          this.$emit('openElemSetDialog', toolBar)
          break
        case 'viewport':
          this.openViewPortPanel(toolBar)
          break
        case 'annotation':
          this.$emit('openAnnotationPanel', toolBar)
          break
        case 'roaming':
          this.openRoaming(toolBar)
          break
        case 'anchor':
          this.$emit('openAnchorPanel', toolBar)
          break
      }
    },
    isActive(toolBar) {
      return this.activeToolBar === toolBar
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    isMobileDevice
  }
}
</script>

<style lang="less" scoped>
.header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 14px;
  padding-right: 32px;
  background: var(--header-bg-color);
  height: 64px;
  border-bottom: 1px solid var(--eng-header-border-color);
  box-shadow: var(--base-bg-dark-color30);

  .scene-name-box {
    display: flex;
    align-items: center;

    .icon-box {
      font-size: 18px;
      color: var(--aside-bg-color);
      cursor: pointer;
      padding: 15px 15px;
      border-radius: 16px;
      margin-right: 16px;
      background: var(--base-primary-bgColor);
    }

    .name-box {
      max-width: 400px;
      font-size: 20px;
      font-weight: 400;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: var(--eng-header-text-color);
    }
  }

  .toolbar-box {
    display: flex;
    align-items: center;

    .item-box {
      margin: 0px 2px;
      width: 64px;
      padding: 6px 4px 4px 4px;
      border-radius: 8px;
      cursor: pointer;

      &:first {
        margin-left: 0px;
      }

      &:last-child {
        margin-right: 0px;
      }

      &.active {
        color: var(--base-primary-bgColor);
        background: var(--base-bg-light-color24);
        .name-box {
          color: var(--base-primary-bgColor);
        }
        .icon-box {
          .icon {
            color: var(--base-primary-bgColor);
          }
        }

        &:hover {
          background: var(--base-bg-light-color24);
        }
      }

      &:hover {
        background: var(--eng-header-toolbar-hover-bgColor);
      }

      .icon-box {
        .icon {
          margin: auto;
          color: var(--eng-header-toolbar-text-color);
        }
      }

      .name-box {
        font-size: 14px;
        margin-top: 4px;
        color: var(--eng-header-toolbar-text-color);
      }
    }
  }
}
</style>
